module.exports = "<ngx-spinner bdColor=\"rgba(51,51,51,0.8)\"\n             size=\"medium\"\n             color=\"#fff\"\n             type=\"ball-spin-clockwise-fade\">\n</ngx-spinner>\n<router-outlet></router-outlet>\n<div class=\"clearfix\"></div>\n<app-message></app-message>\n"


//////////////////
// WEBPACK FOOTER
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main